import React from 'react';
import { Form, Card, Button } from 'react-bootstrap';
import { Routes, Route, Link } from 'react-router-dom';
import { Container, Nav, Navbar } from 'react-bootstrap';

function EuroKarsRef2() {
    return (
        <>
            <header>
                <div class="header_top_nav">
                    <div class="container-lg">
                        <div class="header_top_nav_content">
                            <div class="social_media">
                                <ul>
                                    <li>
                                        <a href="#">
                                            <i class="fa-brands fa-linkedin-in"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <i class="fa-brands fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#">
                                            <i class="fa-brands fa-facebook-f"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="contect_number">
                                <i class="fi fi-rr-phone-call"></i>
                                <a href="tel:+65 6331 0600">+65 6331 0600</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="header_main">
                    <div class="container-lg">
                        <nav class="navbar navbar-expand-md">
                            <div class="navbar-wrap">
                                <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                                    <i class="fi fi-rr-menu-burger"></i>
                                </button>
                                <div class="navbar_logo">
                                    <a class="navbar-brand" href="./index.html">
                                        <img src="../assets/image/logo.svg" alt="" />
                                    </a>
                                </div>

                                <div class="collapse navbar-collapse" id="navbarText">
                                    <div class="nav_icon d-md-none d-block">
                                        <img src="../assets/image/home.svg" alt="" />
                                    </div>
                                    <ul class="navbar-nav ms-auto">
                                        <li class="nav-item dropdown navbar-brand-dropdown">
                                            <a class="nav-link dropdown-toggle" href="./financing.html" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                Financing <i class="fi fi-rr-caret-down"></i>
                                            </a>
                                            <ul class="dropdown-menu">
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="./apply_loan.html">Apply Loan</a>
                                                </li>
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="#">Apply eGIRO</a>
                                                </li>
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="#">WhatsApp Us</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item dropdown navbar-brand-dropdown">
                                            <a class="nav-link dropdown-toggle" href="./insurance.html" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                Insurance <i class="fi fi-rr-caret-down"></i>
                                            </a>
                                            <ul class="dropdown-menu">
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="./get_quotation.html">Get Quotation</a>
                                                </li>
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="./renew_my_policy.html">Renew My Policy</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./the_group.html">The Group</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./news.html">Newsroom</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./contact_us.html">Contact Us</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./sign_in.html">Dealer Sign In</a>
                                        </li>
                                    </ul>
                                    <div class="button">
                                        <a href="./apply_loan.html" class="btn btn_primary">Apply Loan</a>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>
            <header class="header_sticky">
                <div class="header_main">
                    <div class="container-lg">
                        <nav class="navbar navbar-expand-md">
                            <div class="navbar-wrap">
                                <button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTextSticky" aria-controls="navbarTextSticky" aria-expanded="false" aria-label="Toggle navigation">
                                    <i class="fi fi-rr-menu-burger"></i>
                                </button>
                                <div class="navbar_logo">
                                    <a class="navbar-brand" href="./index.html">
                                        <img src="../assets/image/logo.svg" alt="" />
                                    </a>
                                </div>

                                <div class="collapse navbar-collapse" id="navbarTextSticky">
                                    <div class="nav_icon d-md-none d-block">
                                        <img src="../assets/image/home.svg" alt="" />
                                    </div>
                                    <ul class="navbar-nav ms-auto">
                                        <li class="nav-item dropdown navbar-brand-dropdown">
                                            <a class="nav-link dropdown-toggle" href="./financing.html" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                Financing <i class="fi fi-rr-caret-down"></i>
                                            </a>
                                            <ul class="dropdown-menu">
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="./apply_loan.html">Apply Loan</a>
                                                </li>
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="#">Apply eGIRO</a>
                                                </li>
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="#">WhatsApp Us</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item dropdown navbar-brand-dropdown">
                                            <a class="nav-link dropdown-toggle" href="./insurance.html" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                                                Insurance <i class="fi fi-rr-caret-down"></i>
                                            </a>
                                            <ul class="dropdown-menu">
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="./get_quotation.html">Get Quotation</a>
                                                </li>
                                                <li class="sub_list">
                                                    <a class="dropdown-item" href="./renew_my_policy.html">Renew My Policy</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./the_group.html">The Group</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./news.html">Newsroom</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./contact_us.html">Contact Us</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="./sign_in.html">Dealer Sign In</a>
                                        </li>
                                    </ul>
                                    <div class="button">
                                        <a href="./apply_loan.html" class="btn btn_primary">Apply Loan</a>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </header>

            <section class="position-relative-none">
                <div class="content content_wrap">
                    <div class="container-lg">
                        <div class="webmaster_wrap">
                            <div class="row">
                                <div class="col-md-9">
                                    <div class="info">
                                        <i class="fi fi-rr-info"></i>
                                        <p>
                                            Web Master Consultancy Pte Ltd is hosting this application
                                            and request Myinfo on behalf of WebClouds Pte Ltd. The data
                                            retrieved from Myinfo are secured and encrypted.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="box">
                                <div class="row row_gap">
                                    <div class="col-md-6">
                                        <div class="inner_box">
                                            <h3 class="box_title">Use Myinfo</h3>
                                            <div class="img_icon">
                                                <img src="../assets/image/singpass_logo.svg" alt="" />
                                            </div>
                                            <div class="text">
                                                <p>
                                                    Register with Singpass to use relevant Myinfo data
                                                    pre-fill the form for hassle-free application.
                                                </p>
                                            </div>
                                            <div class="button">
                                                <a href="./apply_loan.html" class="btn btn_primary btn-danger">
                                                    Retrieve Myinfo with singpass
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="inner_box">
                                            <h3 class="box_title">
                                                Complete an online application form
                                            </h3>
                                            <div class="img_icon">
                                                <img src="../assets/image/clarity_note_icon.png" alt="" />
                                            </div>
                                            <div class="text">
                                                <p>
                                                    For foreigners or Singaporeans and Singapore PRs who do
                                                    not have access to Singpass.
                                                </p>
                                            </div>
                                            <div class="button">
                                                <a href="./apply_loan.html" class="btn btn_primary btn-outline">
                                                    Continue without Myinfo
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <footer>
                <div class="footer_top_content">
                    <div class="container-lg">
                        <div class="row">
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="footer_start_content">
                                    <div class="logo">
                                        <img src="../assets/image/logo.svg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row footer_row">
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="footer_start_content">
                                    <div class="footer_title">
                                        <p>Contact Details</p>
                                    </div>
                                    <ul class="icon_text">
                                        <li class="icon_text_inner">
                                            <div class="icon">
                                                <i class="fi fi-rr-marker"></i>
                                            </div>
                                            <div class="text">
                                                <p>11 Kung Chong Road Singapore 159147</p>
                                            </div>
                                        </li>
                                        <li class="icon_text_inner">
                                            <div class="icon">
                                                <i class="fi fi-rr-envelope"></i>
                                            </div>
                                            <div class="text">
                                                <a class="text-lowercase" href="mailto:loans@eurokars.com.sg">
                                                    loans@eurokars.com.sg
                                                </a>
                                            </div>
                                        </li>
                                        <li class="icon_text_inner">
                                            <div class="icon">
                                                <i class="fi fi-rr-phone-call"></i>
                                            </div>
                                            <div class="text">
                                                <a href="tel:+65 6363 3003">+65 6363 3003 </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-xl-3 col-lg-4 col-md-6">
                                <div class="footer_link_content">
                                    <div class="footer_title">
                                        <p>Operating Hours</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <ul>
                                                <li>
                                                    <p>Monday - Thursday: 8.30am - 6.00pm</p>
                                                </li>
                                                <li>
                                                    <p>Friday: 8.30am - 5.30pm</p>
                                                </li>
                                                <li>
                                                    <p>Weekends &amp; PH: Closed</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-4 col-md-6">
                                <div class="footer_link_content footer_end_content">
                                    <div class="footer_title">
                                        <a href="https://www.eurokarsgroup.com/" target="_blank">Eurokars Group</a>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="text">
                                                <p>Eurokars Financial Services (EFS) is a subsidiary of Eurokars Group, dedicated to delivering premium automotive excellence through passion. Driving luxury experiences since 1985.</p>
                                                <a href="https://www.eurokarsgroup.com/" target="_blank" class="footer_link_common">Click here to find out more.</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-2 col-lg-4 col-md-6">
                                <div class="footer_link_content footer_end_content">
                                    <div class="footer_title">
                                        <p>Legal</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="footer_link">
                                                <ul>
                                                    <li>
                                                        <a href="https://www.eurokarsgroup.com/data-protection" target="_blank">Data Protection Policy</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer_bottom_content">
                    <div class="container-lg">
                        <div class="row">
                            <div class="col-12">
                                <div class="text text-center">
                                    <p>We use cookies to ensure that we give you the best experience on our website. By using our website, you agree to our&nbsp;Privacy Policy&nbsp;&amp;&nbsp;Cookie Policy.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default EuroKarsRef2;